import { z } from 'zod';
import { paginationQuerySchema, uuidSchema } from './common.js';
const text = (max) => z
    .string()
    .trim()
    .max(max)
    .refine((v) => !v.includes('\u0000'), 'Invalid character');
/** A new conversation about one student, with the people it is addressed to. */
export const createThreadSchema = z.object({
    studentId: uuidSchema,
    subject: text(200)
        .min(1)
        .refine((v) => !/[\r\n]/.test(v), 'The subject must be a single line'),
    body: text(4000).min(1),
    recipientIds: z
        .array(uuidSchema)
        .min(1, 'Choose at least one person')
        .max(10)
        .refine((ids) => new Set(ids).size === ids.length, 'A person can be chosen only once'),
});
export const replySchema = z.object({ body: text(4000).min(1) });
export const listThreadsQuerySchema = paginationQuerySchema;
export const recipientsQuerySchema = z.object({ studentId: uuidSchema });
//# sourceMappingURL=messages.js.map